import { useState } from "react";

export const useFileValidation = () => {
  const [file, setFile] = useState<File>();
  const [error, setError] = useState<string>("");
  const [orderCount, setOrderCount] = useState<number>(0);
  const [redriveOK, setRedriveOK] = useState<boolean>(false);

  const validateFileSize = (thisFile: File) => {
    if (thisFile.size === 0) {
      setError("File is empty. Please choose another.");
      return false;
    }
    return true;
  };

  const handleFileChange = (files: File[]) => {
    setFile(files[0]);
    setRedriveOK(false);
  };

  const validateLineFormat = (line: string) => {
    const trimmed = line.trim();
    if (trimmed.length === 0 || trimmed.includes(",")) {
      return false;
    }
    return true;
  };

  const validateDuplicates = (lines: string[]) => {
    const lineSet = new Set<string>();
    const duplicates = new Set<string>();

    for (const line of lines) {
      if (lineSet.has(line)) {
        duplicates.add(line);
      }
      lineSet.add(line);
    }

    if (duplicates.size > 0) {
      setError(
        `${duplicates.size} duplicate order id${
          duplicates.size === 1 ? "" : "s"
        } found. Please remove duplicates before continuing (see below).`
      );
      return false;
    }

    return true;
  };

  const loadedFileCallback = (fileText: string) => {
    const lines = fileText.split("\n").filter((line) => line.trim() !== "");

    setOrderCount(lines.length);
    alert(
      `This file contains ${lines.length} orders. Are you sure you wish to continue?`
    );
    let isok = true;

    for (const line of lines) {
      if (!validateLineFormat(line)) {
        setError(
          "Invalid line format. File should contain one ID per line with no commas."
        );
        isok = false;
        break;
      }
    }

    if (isok && !validateDuplicates(lines)) {
      isok = false;
    }

    setRedriveOK(isok);
    if (isok) {
      setError("");
    }

    return isok;
  };

  const checkFile = (thisFile: File) => {
    if (!validateFileSize(thisFile)) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        loadedFileCallback(e.target.result.toString());
      }
    };
    reader.readAsText(thisFile);
  };

  const validateRedrive = () => {
    if (file) {
      if (file.type === "text/csv") {
        checkFile(file);
      } else {
        setError("File type must be a CSV. Please upload another");
      }
    } else {
      setError("Please upload a csv file");
    }
  };

  const removeDuplicates = () => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        const fileText = e.target.result.toString();
        const lines = fileText.split("\n").filter((line) => line.trim() !== "");
        const uniqueLines = [...new Set(lines)];

        const cleanedContent = uniqueLines.join("\n");
        const blob = new Blob([cleanedContent], { type: "text/csv" });
        const cleanedFile = new File([blob], file.name, { type: "text/csv" });

        setFile(cleanedFile);
        setRedriveOK(false);
        setError("");
      }
    };
    reader.readAsText(file);
  };

  return {
    file,
    orderCount,
    error,
    redriveOK,
    handleFileChange,
    validateRedrive,
    setError,
    removeDuplicates,
  };
};
